import { render, staticRenderFns } from "./niuEnTaiContract.vue?vue&type=template&id=2c8fcf80&scoped=true"
import script from "./niuEnTaiContract.vue?vue&type=script&lang=js"
export * from "./niuEnTaiContract.vue?vue&type=script&lang=js"
import style0 from "./niuEnTaiContract.vue?vue&type=style&index=0&id=2c8fcf80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8fcf80",
  null
  
)

export default component.exports